import React            from 'react';
import BoxGrid          from 'pages/tirgul/dndQuestion/BoxGrid';
import Droppable        from 'pages/tirgul/dndQuestion/Droppable';

type DndPropsType = {
    size:         number[];
    question:     number;
    wideScreen:   boolean;
    shake:        boolean;
    lastTest:     boolean;
    feedBack:     string;
    goToNextTest: () => void;
}

const Dnd: React.FC<DndPropsType> = ({ 
    size, 
    wideScreen, 
    shake, 
    question, 
    lastTest,
    feedBack,
    goToNextTest
}) => {

    
    return(
        <>
             {
                 wideScreen && 
                 <BoxGrid
                    size  = { size }
                    range = { 1 }
                    wideScreen
                 />
             }
             <Droppable 
                size         = { size }
                question     = { question }
                wideScreen   = { wideScreen }
                feedBack     = { feedBack }
                lastTest     = { lastTest }
                shake        = { shake }
                goToNextTest = { goToNextTest }
             />
             {
                 !wideScreen && 
                 <BoxGrid
                    size       = { size }
                    range      = { 1 }
                    wideScreen = { false }
                 />
             }
             <BoxGrid
                size       = { size }
                range      = { 6 }
                wideScreen = { wideScreen }
             />
        </>
    )
}

  export default Dnd

  
